import React from 'react';
const Wa_Channel_Add=(props)=>{
    //alert(JSON.stringify(props));
        return(<div className="modal fade bd-example-modal-xl"  id="divWaThrashold" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">Add Channel</h5>
              <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
            <form id="frmWaThrashold" name="frmWaThrashold">
           
            <div className="modal-body">
            <div className="row">
                      {/* <!-- left column --> */}
                      <div className="col-md-12">
                          <div className="card card-danger">
                                  <input type="hidden" name="res_func" id="res_func" value="okSucc" />
                                  <input type="hidden" name="curl_type" id="curl_type" value="addNewChannel" />
                                  <input type="hidden" name="m_type" id="m_type" value="addNewChannel" />
                                  <input type="hidden" name="type_id" id="type_id" value="2" />
                                  <input type="hidden" name="local_token" id="local_token" value={props.user_object[0].app_user_id} />
                                  <div className="card-body">
                                      <div className="row">
                                      <div className="col-lg-12 col-md-12">
                                              <div className="form-group">
                                                  <label for="exampleInputEmail1">Contact No</label>
                                                  <input type="text" id="contact_no" name="contact_no" className="form-control required" placeholder="Contact No." />
                                              </div>
                                          </div>

                                          <div className="col-lg-12 col-md-12">
                                              <div className="form-group">
                                                  <label for="exampleInputEmail1">Instance ID</label>
                                                  <input type="text" id="token_id" name="token_id" className="form-control required" placeholder="Instance ID" />
                                              </div>
                                          </div>
                                          <div className="col-lg-12 col-md-12">
                                              <div className="form-group">
                                                  <label for="exampleInputEmail1">Access Token</label>||
                                                  <input type="text" id="access_token" name="access_token" className="form-control required" placeholder="Access Token" />
                                              </div>
                                          </div>
                                          
                                          <div className="col-lg-12 col-md-12">
                                              <div className="form-group">
                                                  <label for="exampleInputEmail1">Status</label>
                                                  <select id="status" name="status" className="form-control">
                                                    <option value={"1"}>Active</option>
                                                    <option value={"0"}>Deactive</option>
                                                  </select>
                                              </div>
                                          </div>
                                      </div>
                                    
                                      <div className="col-md-6 respSSL"></div>
                                      <div id="testing2dd2222"></div>
                                  </div>
                              
                          </div>
                      </div>
                  </div>
            </div>
            <div className="modal-footer">
            <div id="getReponse" style={{color:"red"}}></div>
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="button" className="btn _btnSetColor btn-primary">Save changes</button>
            </div>
            </form>
          </div>
          </div>
          </div>
      );
    
}
export default Wa_Channel_Add;
